import React from "react";
import PropTypes from "prop-types/prop-types";
import CodeAssignmentPage from "./pages/CodeAssignmentPage/CodeAssignmentPage";
import {Route, Routes} from "react-router";
import {HashRouter} from "react-router-dom";
import TestSummaryPage from "./pages/TestSummaryPage/TestSummaryPage";
import FeedbackPage from "./pages/FeedbackPage/FeedbackPage.tsx";
import TestStartPage from "./pages/TestStartPage/TestStartPage";
import NotFoundPage from "./pages/NotFoundPage/NotFoundPage";
import Header from "./components/Header/Header";
import {SnackbarProvider} from "notistack";
import {CookiesProvider, withCookies} from "react-cookie";
import i18n from "./i18n/i18n";
import {I18nextProvider} from "react-i18next";
import ApplicationRootPage from "./pages/ApplicationRootPage/ApplicationRootPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage/PrivacyPolicyPage";
import { withStyles } from 'tss-react/mui';
import {ThemeProvider, StyledEngineProvider, CssBaseline} from "@mui/material";
import theme from "./theme/theme";
import snackbarStyledContent from "./theme/snackbarStyling";
import {SuccessIcon, InfoIcon, WarningIcon, ErrorIcon} from "./utils/AlertIcons";

const styles = {
    routedPage: {
        margin: "64px 10% 0", // HACK: magic number - toolbar height
        padding: "30px 0",
        width: "100%",
    },
    snackbarIcon: {
        marginRight: theme.spacing(1),
        opacity: 0.9,
    },
};

class App extends React.Component {
    render() {
        const {classes} = this.props;

        return (
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme}>
                    <I18nextProvider i18n={i18n}>
                        <SnackbarProvider
                            maxSnack={5}
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "right",
                            }}
                            Components={{
                                success: snackbarStyledContent,
                                error: snackbarStyledContent,
                                info: snackbarStyledContent,
                                warning: snackbarStyledContent,
                            }}
                            iconVariant={{
                                success: <SuccessIcon className={classes.snackbarIcon}/>,
                                error: <ErrorIcon className={classes.snackbarIcon}/>,
                                warning: <WarningIcon className={classes.snackbarIcon}/>,
                                info: <InfoIcon className={classes.snackbarIcon}/>,
                            }}
                        >
                            <CssBaseline/>
                            <Header/>
                            <CookiesProvider>
                                <div className={classes.routedPage}>
                                    <HashRouter>
                                        <Routes>
                                            <Route path="/start/:securityCode" element={<TestStartPage/>}/>
                                            <Route path="/test/:securityCode" element={<CodeAssignmentPage/>}/>
                                            <Route path="/summary" element={<TestSummaryPage/>}/>
                                            <Route path="/feedback/:securityCode" element={<FeedbackPage/>}/>
                                            <Route path="/privacy-policy" element={<PrivacyPolicyPage/>}/>
                                            <Route path="/not_found" element={<NotFoundPage/>}/>
                                            <Route path="/" exact element={<ApplicationRootPage/>}/>
                                            <Route path="*" exact element={<NotFoundPage/>}/>
                                        </Routes>
                                    </HashRouter>
                                </div>
                            </CookiesProvider>
                        </SnackbarProvider>
                    </I18nextProvider>
                </ThemeProvider>
            </StyledEngineProvider>
        );
    }
}

App.propTypes = {
    classes: PropTypes.object.isRequired,
    // Injected by the documentation to work in an iframe.
    // You won't need it on your project.
    container: PropTypes.object,
    theme: PropTypes.object.isRequired,
};

const AppWithStyles = withStyles(App, styles, {withTheme: true});

export default withCookies(AppWithStyles);
